import {PlayerEnums} from '../GameEnums'
import PlayerConstants = PlayerEnums.PlayerConstants
import {ArrayUtils} from './ArrayUtils'
import {isValueStringBetween} from '@colonist/validation'
import names from './names.json'

const TAG_LENGTH = 4
const GUEST_USERNAME_REGEX = /^[a-zA-Z]+#[0-9]{4}$/

export function randomName(): string {
    return ArrayUtils.randomElementFromArray(names)
}

function createUsernameTag(): string {
    return '#' + getRandomTagNumber()
}

export function getRandomTagNumber(): string {
    const randomNumber = (new Date().getTime()).toString()
    return randomNumber.substr(randomNumber.length - TAG_LENGTH)
}

// TODO: isolate in shared, move others to client
export function hasUsernameTag(name: string): boolean {
    return name.charAt(name.length - (TAG_LENGTH + 1)) === '#'
}

export function removeUsernameTag(name: string): string {
    return name.slice(0, name.length - (TAG_LENGTH + 1))
}

export function removeUsernameHash(name: string): string {
    return name.replace('#', '')
}

export function createGuestUsername(name?: string): string {
    // 20000 names * 10000 tags
    // There is 1/200M chance for a username to collide.
    if(name) {
        return name + createUsernameTag()
    }
    return randomName() + createUsernameTag()
}

export function createBotName(): string {
    return randomName()
}

export function isGuestUsernameLengthValid(text: string): boolean {
    return isValueStringBetween(text, PlayerConstants.MIN_USERNAME_LENGTH, PlayerConstants.MAX_GUEST_USERNAME_LENGTH)
}

export function isRegisteredUsernameLengthValid(text: string): boolean {
    return isValueStringBetween(text, PlayerConstants.MIN_USERNAME_LENGTH, PlayerConstants.MAX_USERNAME_LENGTH)
}

export function isGuestUsernameValid(text: string): boolean {
    return GUEST_USERNAME_REGEX.test(text)
}
